import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Box, Text, Button } from 'grommet';
import { Step } from './step';

import { openLayer } from '../../../actions/layers';

const Explain = (props) => {
  const { openLayer } = props;

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box
          direction='row'
          justify='center'
          margin={{ horizontal: 'medium', top: '100px' }}
        >
          <Box
            pad='small'
            width='xlarge'
          >
            <Box
              direction='row'
              gap={ size === 'small' ? 'small' : 'large' }
              align='start'
              justify='between'
            >
              {/* primeira coluna */}
              <Box
                gap={ size === 'small' ? 'small' : 'medium' }
                width={
                  size === 'small' || size === 'xsmall' ? 'xlarge' : 'large'
                }
                fill
              >
                {/* O que é */}
                <Box
                  gap={ size === 'small' ? 'medium' : 'small' }
                >
                  <Text color='brand' size='large' weight='bold'>
                    Detalhamento por município.
                  </Text>

                  <Text color='dark-2' size='small'>
                    Confira como foi a votação em cada município, candidatos eleito, segundo turno e muito mais.
                  </Text>
                </Box>


                {/* Como funciona */}
                <Box
                  gap={ size === 'small' ? 'medium' : 'small' }
                >
                  <Text color='dark-1' size='medium'>Como funciona?</Text>

                  <Step
                    index={1}
                    description='Acesse os filtros e selecione um estado.'
                  />

                  <Step
                    index={2}
                    description='Clique em buscar e começe analisar!'
                  />

                  <Button
                    label='Começar'
                    color='dark-3'
                    onClick={openLayer}
                  />
                </Box>

                {/* O que fazer */}
                <Box
                  gap={ size === 'small' ? 'medium' : 'small' }
                >
                  <Text color='dark-1' size='medium'>O que é possível?</Text>

                  <Step icon description='Filtrar por cidade.' />
                  <Step icon description='Detalhamento da votação nas cidades.' />
                  <Step icon description='Visualize os candidatos por cidade.' />
                </Box>

                {/* Fonte */}
                <Box
                  gap={ size === 'small' ? 'medium' : 'small' }
                  margin={{ horizontal: 'medium' }}
                >
                  <Text size='xsmall' color='dark-1'>As informações dessa funcionalidade são do TSE.</Text>
                </Box>
              </Box>

              {/* Separador coluna */}
              {(size !== 'xsmall' && size !== 'small') ? (
                <Box
                  width={ size === 'large' || size === 'xlarge' ? 'xsmall' : 'xxsmall'}
                />) : null}

              {/* segunda coluna */}
              {(size !== 'xsmall' && size !== 'small') ? (
                <Box
                  width={ size === 'small' || size === 'medium' ? 'xsmall' : 'large' }
                  align='end'
                />) : null}
            </Box>
          </Box>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  )
};

const mapStateToProps = null;

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    openLayer,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Explain);

